import { createWebSocketStore } from 'src/components/#services/helpers';
export const audience = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'user',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'profile_getNum',
    },
});
export const userBalances = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'transactions',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'balance_getAllLisSum',
    },
});
export const getCountActives = createWebSocketStore({
    auth: false,
    requestTemplate: {
        agent: 'user',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'profile_getCountActives',
    },
});
export const getLootboxesAnalyticsCount = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'transactions',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'analyticTransaction_getCount',
    },
});
export const getLootboxesCountFromSpins = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'analytics',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'rewards_getLootboxesCountFromSpins',
    },
});
export const getLootboxesCountFromDailyQuests = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'analytics',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'rewards_getLootboxesCountFromDailyQuests',
    },
});
